<template>
	<v-dialog persistent width="auto" v-model="dialog" v-if="selectedTerraMapping">
		<v-card
			style="min-height: 60vh; max-height: 80vh; width: 33vw; min-width: 400px"
			class="overflow-auto d-flex flex-column">
			<v-card-title class="card-header text-left fixed-card-title2">
				<v-row no-gutters>
					<v-col class="align-center d-flex" cols="10">
						<v-toolbar-title>{{ $t('terra-patient-integration-details') }}</v-toolbar-title>
					</v-col>
					<v-spacer />
					<v-icon @click="$emit('closeDialog')" color="white">mdi-close</v-icon>
				</v-row>
			</v-card-title>
			<v-card-text class="pa-4 flex-grow-1 d-flex flex-column">
				<div class="flex-grow-1">
					<v-row dense class="ma-0">
						<v-col cols="6" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('provider') }}:</div>
							<div class="text-body-1">{{ selectedTerraMapping.provider }}</div>
						</v-col>
						<v-col cols="6" class="text-right">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('active') }}:</div>
							<div class="text-body-1">
								<v-icon :color="selectedTerraMapping.active ? 'green' : 'red'">
									{{ selectedTerraMapping.active ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}
								</v-icon>
							</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('data-coordinator') }}:</div>
							<div class="text-body-1">
								{{
									findUserName(selectedTerraMapping.ecpUserInpersonateId, selectedTerraMapping.locationId) ||
									$t('no-data')
								}}
							</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('location-name') }}:</div>
							<div class="text-body-1">{{ selectedTerraMapping.locationName }}</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('organization-name') }}:</div>
							<div class="text-body-1">{{ selectedTerraMapping.organizationName }}</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('terra-user-id') }}:</div>
							<div class="text-body-1">{{ selectedTerraMapping.terraUserId }}</div>
						</v-col>
						<v-col cols="12" class="text-left" v-if="selectedTerraMapping.lastWebhookUpdate">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('last-updated-at') }}:</div>
							<div class="text-body-1">
								{{
									selectedTerraMapping.lastWebhookUpdate
										? formatTimestamp(selectedTerraMapping.lastWebhookUpdate, 'datetime_med')
										: $t('no-data')
								}}
							</div>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-row dense class="ma-0">
					<v-col class="text-left">
						<span class="text-subtitle-1 font-weight-bold">{{ $t('timestamp') }}:</span>
						<span class="text-body-1">
							{{ formatTimestamp(selectedTerraMapping.terraMappingCreatedAt, 'datetime_med') }}
						</span>
					</v-col>
					<v-col class="text-right">
						<span class="text-subtitle-1 font-weight-bold">{{ $t('user-name') }}:</span>
						<span class="text-body-1">{{ selectedTerraMapping.userName }}</span>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { formatTimestamp } from '@/utils/utilities';
import { mapState } from 'vuex';
export default {
	name: 'TerraPatientIntegrationDialog',
	props: ['dialog', 'selectedTerraMapping'],
	computed: {
		...mapState({
			ecpUsers: (state) => state.terra.ecpUsers,
		}),
	},
	methods: {
		formatTimestamp,
		findUserName (userId, locationId) {
			if (!userId) return this.$t('none');
			const location = this.ecpUsers.find((loc) => loc.locationId === locationId);
			if (location) {
				const user = location.ecpUserForTerraDto.find((u) => u.id === userId);
				return user ? user.userName : this.$t('none');
			}
			return this.$t('none');
		},
	},
};
</script>
